<template>
  <span>
    <slot v-bind="{ status, isReady, isLoading, isProcessing }">
      {{ status }}
    </slot>
  </span>
</template>

<script>
export default {
  props: {
    resource: {
      type: String,
      required: true,
    },
    resourceId: {
      type: [String, Number],
      required: true,
    },
    postProcessing: {
      type: Function,
      required: false,
    }
  },
  name: "QueuetonResourceStatus",
  computed: {
    status() {
      return this.$store.getters['queueton/resourceStatusOrig'](this.resource, this.resourceId);
    },
    isReady() {
      return ['idle', 'error'].includes(this.status);
    },
    isLoading() {
      return ['waiting'].includes(this.status);
    },
    isProcessing() {
      return !['idle', 'error', 'waiting'].includes(this.status);
    }
  },
  watch: {
    isProcessing(current, previous) {
      if (previous && !current) {
        this.postProcessing && this.postProcessing();
      }
    }
  },
  beforeMount() {
    this.$store.dispatch('queueton/addResource', { type: this.resource, id: this.resourceId });
  },
  beforeDestroy() {
    this.$store.dispatch('queueton/removeResource', { type: this.resource, id: this.resourceId });
  },
}
</script>
